/** Employment subcategory options and industry/status mapping. Values match API EmploymentSubcategory enum. */

export const EMPLOYMENT_SUBCATEGORY = {
  // Financial Services
  BANK_EMPLOYEE: 1,
  INSURANCE_AGENT: 2,
  FINANCIAL_CONSULTANT: 3,
  WEALTH_MANAGER: 4,
  RISK_MANAGER: 5,
  AUDITOR: 6,
  ACCOUNTANT: 7,
  OTHER_FINANCIAL: 8,
  // Employed (Private Sector)
  ADMINISTRATIVE: 9,
  CONSULTANT: 10,
  CUSTOMER_SERVICE: 11,
  FINANCIAL_ANALYST: 12,
  PROJECT_MANAGER: 13,
  SCIENTIST: 14,
  OTHER_PRIVATE_SECTOR: 15,
  // Government
  GOVERNMENT_EMPLOYEE: 16,
  MILITARY_SECTOR: 17,
  CUSTOMS: 18,
  DIPLOMAT: 19,
  PROSECUTOR: 20,
  MUNICIPALITY_EMPLOYEE: 21,
  OTHER_GOVERNMENT: 22,
  // Business Owner
  SOLE_PROPRIETOR: 23,
  COMPANY_OWNER: 24,
  SHAREHOLDER: 25,
  MANAGING_DIRECTOR: 26,
  IMPORT_EXPORT_BUSINESS: 27,
  CONSTRUCTION_BUSINESS: 28,
  MANUFACTURING_BUSINESS_SPECIFY: 29,
  ECOMMERCE_BUSINESS: 30,
  OTHER_BUSINESS_OWNER: 31,
  // Education
  STUDENT: 32,
  TUTOR: 33,
  EDUCATION_ADMINISTRATOR: 34,
  OTHER_EDUCATION: 35,
  // Healthcare
  DOCTOR: 36,
  PHARMACIST: 37,
  NURSE: 38,
  PHYSIOTHERAPIST: 39,
  OTHER_HEALTHCARE: 40,
  // Legal
  LAWYER: 41,
  NOTARY: 42,
  JUDGE: 43,
  PARALEGAL: 44,
  OTHER_LEGAL: 45,
  // IT
  SOFTWARE_ENGINEER: 46,
  NETWORK_ENGINEER: 47,
  AI_ENGINEER: 48,
  SYSTEMS_ENGINEER: 49,
  IT_CONSULTANT: 50,
  OTHER_IT: 51,
  // Engineering
  CIVIL_ENGINEER: 52,
  MECHANICAL_ENGINEER: 53,
  ELECTRICAL_ENGINEER: 54,
  CHEMICAL_ENGINEER: 55,
  CONSTRUCTION_MANAGER: 56,
  SURVEYOR: 57,
  ARCHITECT: 58,
  OTHER_ENGINEERING: 59,
  // Sales & Marketing
  SALES_MANAGER: 60,
  MARKETING_MANAGER: 61,
  REAL_ESTATE_AGENT: 62,
  OTHER_SALES_MARKETING: 63,
  // Transportation
  PILOT: 64,
  DRIVER: 65,
  CAPTAIN: 66,
  LOGISTICS_MANAGER: 67,
  WAREHOUSE_MANAGER: 68,
  OTHER_TRANSPORTATION: 69,
  // Hospitality
  HOSPITALITY_MANAGER_EMPLOYEE: 70,
  TRAVEL_AGENT: 71,
  OTHER_HOSPITALITY: 72,
  // Agriculture & Manufacturing
  FARMER: 73,
  MANUFACTURER: 74,
  FACTORY_WORKER: 75,
  FISHERMAN: 76,
  OTHER_AGRICULTURE_MANUFACTURING: 77,
  // Other occupation
  RETIRED: 78,
  UNEMPLOYED: 79,
  PENSIONER: 80,
  INVESTOR: 81,
  PROFESSIONAL_TRADER: 82,
  OTHER_OCCUPATION: 83,
};

const L = (value, label) => ({ value, label });

const FINANCIAL = [
  L(1, "Bank Employee"),
  L(2, "Insurance Agent"),
  L(3, "Financial Consultant"),
  L(4, "Wealth Manager"),
  L(5, "Risk Manager"),
  L(6, "Auditor"),
  L(7, "Accountant"),
  L(8, "Other (Specify)"),
];

const PRIVATE_SECTOR = [
  L(9, "Administrative"),
  L(10, "Consultant"),
  L(11, "Customer Service"),
  L(12, "Financial Analyst"),
  L(13, "Project Manager"),
  L(14, "Scientist"),
  L(15, "Other (Specify)"),
];

const GOVERNMENT = [
  L(16, "Government Employee"),
  L(17, "Military Sector"),
  L(18, "Customs"),
  L(19, "Diplomat"),
  L(20, "Prosecutor"),
  L(21, "Municipality Employee"),
  L(22, "Other (Specify)"),
];

const BUSINESS_OWNER = [
  L(23, "Sole Proprietor"),
  L(24, "Company Owner"),
  L(25, "Shareholder"),
  L(26, "Managing Director"),
  L(27, "Import & Export Business"),
  L(28, "Construction Business"),
  L(29, "Manufacturing Business (Specify)"),
  L(30, "E-commerce Business"),
  L(31, "Other (Specify)"),
];

const EDUCATION = [
  L(32, "Student"),
  L(33, "Tutor"),
  L(34, "Administrator"),
  L(35, "Other (Specify)"),
];

const HEALTHCARE = [
  L(36, "Doctor"),
  L(37, "Pharmacist"),
  L(38, "Nurse"),
  L(39, "Physiotherapist"),
  L(40, "Other (Specify)"),
];

const LEGAL = [
  L(41, "Lawyer"),
  L(42, "Notary"),
  L(43, "Judge"),
  L(44, "Paralegal"),
  L(45, "Other (Specify)"),
];

const IT = [
  L(46, "Software Engineer"),
  L(47, "Network Engineer"),
  L(48, "AI Engineer"),
  L(49, "Systems Engineer"),
  L(50, "IT Consultant"),
  L(51, "Other (Specify)"),
];

const ENGINEERING = [
  L(52, "Civil Engineer"),
  L(53, "Mechanical Engineer"),
  L(54, "Electrical Engineer"),
  L(55, "Chemical Engineer"),
  L(56, "Construction Manager"),
  L(57, "Surveyor"),
  L(58, "Architect"),
  L(59, "Other (Specify)"),
];

const SALES_MARKETING = [
  L(60, "Sales Manager"),
  L(61, "Marketing Manager"),
  L(62, "Real Estate Agent"),
  L(63, "Other (Specify)"),
];

const TRANSPORTATION = [
  L(64, "Pilot"),
  L(65, "Driver"),
  L(66, "Captain"),
  L(67, "Logistics Manager"),
  L(68, "Warehouse Manager"),
  L(69, "Other (Specify)"),
];

const HOSPITALITY = [
  L(70, "Hospitality Manager / Employee"),
  L(71, "Travel Agent"),
  L(72, "Other (Specify)"),
];

const AGRICULTURE_MANUFACTURING = [
  L(73, "Farmer"),
  L(74, "Manufacturer"),
  L(75, "Factory Worker"),
  L(76, "Fisherman"),
  L(77, "Other (Specify)"),
];

const OTHER_OCCUPATION = [
  L(78, "Retired"),
  L(79, "Unemployed"),
  L(80, "Pensioner"),
  L(81, "Investor"),
  L(82, "Professional Trader"),
  L(83, "Other (Specify)"),
];

/** Values that require the Profession free-text field. */
export const SUBCATEGORY_REQUIRES_PROFESSION = new Set([
  8, 15, 22, 29, 31, 35, 40, 45, 51, 59, 63, 69, 72, 77, 83,
]);

export const ALL_EMPLOYMENT_SUBCATEGORY_OPTIONS = [
  ...FINANCIAL,
  ...PRIVATE_SECTOR,
  ...GOVERNMENT,
  ...BUSINESS_OWNER,
  ...EDUCATION,
  ...HEALTHCARE,
  ...LEGAL,
  ...IT,
  ...ENGINEERING,
  ...SALES_MARKETING,
  ...TRANSPORTATION,
  ...HOSPITALITY,
  ...AGRICULTURE_MANUFACTURING,
  ...OTHER_OCCUPATION,
];

const INDUSTRY = {
  AGRICULTURE: 1,
  ENGINEERING: 2,
  ARTS: 4,
  EDUCATION: 5,
  GOVERNMENT: 6,
  HEALTHCARE: 7,
  HOSPITALITY: 8,
  IT: 9,
  LEGAL: 10,
  MANUFACTURING: 11,
  MEDIA_MARKETING: 12,
  TRANSPORTATION: 15,
  OTHER: 16,
  FINANCIAL: 18,
  ENERGY: 21,
  RETAIL: 22,
  REAL_ESTATE: 23,
  NON_PROFIT: 24,
};

const STATUS_BUSINESS_OWNER = 2;

/**
 * @param {number|null|undefined} industry
 * @param {number|null|undefined} employmentStatus
 * @returns {{value:number,label:string}[]}
 */
export function getSubcategoriesForIndustry(industry, employmentStatus) {
  if (employmentStatus === STATUS_BUSINESS_OWNER) {
    return BUSINESS_OWNER;
  }

  switch (industry) {
    case INDUSTRY.FINANCIAL:
      return FINANCIAL;
    case INDUSTRY.GOVERNMENT:
      return GOVERNMENT;
    case INDUSTRY.EDUCATION:
      return EDUCATION;
    case INDUSTRY.HEALTHCARE:
      return HEALTHCARE;
    case INDUSTRY.LEGAL:
      return LEGAL;
    case INDUSTRY.IT:
      return IT;
    case INDUSTRY.ENGINEERING:
      return ENGINEERING;
    case INDUSTRY.MEDIA_MARKETING:
    case INDUSTRY.REAL_ESTATE:
    case INDUSTRY.RETAIL:
      return SALES_MARKETING;
    case INDUSTRY.TRANSPORTATION:
      return TRANSPORTATION;
    case INDUSTRY.HOSPITALITY:
      return HOSPITALITY;
    case INDUSTRY.AGRICULTURE:
    case INDUSTRY.MANUFACTURING:
    case INDUSTRY.ENERGY:
      return AGRICULTURE_MANUFACTURING;
    case INDUSTRY.OTHER:
      return OTHER_OCCUPATION;
    default:
      return PRIVATE_SECTOR;
  }
}

export function subcategoryRequiresProfession(value) {
  return value != null && SUBCATEGORY_REQUIRES_PROFESSION.has(Number(value));
}

export function getSubcategoryLabel(value) {
  const found = ALL_EMPLOYMENT_SUBCATEGORY_OPTIONS.find(
    (o) => o.value === Number(value)
  );
  return found?.label ?? null;
}
